import { Component, OnInit, Inject, PLATFORM_ID, Optional } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-regulatory-signs',
  templateUrl: './regulatory-signs.component.html',
  styleUrls: ['./regulatory-signs.component.scss']
})
export class RegulatorySignsComponent implements OnInit {
  country: string = 'UK'; // Default to UK, can be changed based on detection

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject('ACCEPT_LANGUAGE') private acceptLanguage?: string
  ) {}

  ngOnInit(): void {
    this.detectCountry();
  }

  private detectCountry(): void {
    if (isPlatformBrowser(this.platformId)) {
      // Client-side: could use geo-IP or browser language
      const lang = navigator.language || navigator.languages?.[0] || 'en-GB';
      if (lang.includes('nl')) {
        this.country = 'NL';
      } else if (lang.includes('uk') || lang.includes('en-GB')) {
        this.country = 'UK';
      }
    } else {
      // Server-side: use Accept-Language header if available
      if (this.acceptLanguage) {
        if (this.acceptLanguage.includes('nl')) {
          this.country = 'NL';
        } else if (this.acceptLanguage.includes('en-GB') || this.acceptLanguage.includes('en')) {
          this.country = 'UK';
        }
      }
    }
  }

  isUK(): boolean {
    return this.country === 'UK';
  }

  isNL(): boolean {
    return this.country === 'NL';
  }
}

